import { useEffect } from "react";
import {
  FileChooser,
  InputToggle,
  TextBox,
} from "../../../../components/inputs";

export function AdminDetailsTemplate({ formik, readOnly }) {
  return (
    <div className="grid mt-4 mb-4 grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2">
      <TextBox
        formik={formik}
        readOnly={readOnly}
        name="first_name"
        label="First Name"
        placeholder="First Name"
      />
      <TextBox
        formik={formik}
        readOnly={readOnly}
        name="last_name"
        label="Last Name"
        placeholder="Last Name"
      />
      <TextBox
        formik={formik}
        readOnly={readOnly}
        name="emp_code"
        label="Employee Code"
        placeholder="Employee Code"
      />
      <TextBox
        formik={formik}
        readOnly={readOnly}
        name="designation"
        label="Designation"
        placeholder="Designation"
      />
      <TextBox
        formik={formik}
        readOnly={readOnly}
        name="email"
        label="Email"
        placeholder="Email"
      />
      <TextBox
        formik={formik}
        readOnly={readOnly}
        name="password"
        label="Password"
        type="password"
        placeholder="Password"
      />

      <TextBox
        formik={formik}
        readOnly={readOnly}
        type="tel"
        name="home_phone_number"
        label="Home Phone Number"
        placeholder="Home Phone Number"
      />
      <TextBox
        formik={formik}
        readOnly={readOnly}
        name="work_phone_number"
        type="tel"
        label="Work Phone Number"
        placeholder="Work Phone Number"
      />
      <FileChooser
        formik={formik}
        readOnly={readOnly}
        name="profile_picture"
        label="Profile Picture"
        placeholder="Profile Picture"
        accept=".png,.jpg,.jpeg"
      />
      <InputToggle
        formik={formik}
        readOnly={readOnly}
        name="notifyCustomer"
        label="Notify Customer"
        placeholder="Notify Customer"
      />
    </div>
  );
}
